import { TierLevels } from 'types/session/user'

export const IMAGE_SIZE = 180

export const WELCOME_MESSAGE_IMAGE =
	'/images/spaceMangoLikesYou/welcome-message.jpg'

export const TIER_TITLE_LABELS: Record<TierLevels, string> = {
	[TierLevels.TIER_1]: 'club.welcome.member.text',
	[TierLevels.TIER_2]: 'club.welcome.classic.text',
	[TierLevels.TIER_3]: 'club.welcome.iconic.text',
}
export const TIER_BENEFITS_LABELS: Record<TierLevels, string> = {
	[TierLevels.TIER_1]: 'club.welcome.member.benefits.bodycopy',
	[TierLevels.TIER_2]: 'club.welcome.classic.benefits.bodycopy',
	[TierLevels.TIER_3]: 'club.welcome.iconic.benefits.bodycopy',
}
